export default __webpack_public_path__ + "static/media/mongodb-logo.2f81ed7e.png";